<template>
    <div>
        <el-row>
            <el-select v-model="selectCat" placeholder="Selección de Catálogo" filterable
                @change="getCatalog(selectCat)">
                <el-option v-for="item in cats" :key="item.modelName" :label="item.name" :value="item.modelName">
                </el-option>
            </el-select>
        </el-row>
        <br>

        <span v-if="showGeneric == true">
            <span v-if="label != 'Moneda' && label != 'Sub Partida' && label != 'Productos o Servicios'
                && label != 'Concepto Sub Partida' && label != 'Oficina'">
                <div v-if="selectCat && showTable === true" align="right">
                    <el-button type="success" icon="fas fa-plus" @click="showDialog(label)">
                        Agregar {{ label }}
                    </el-button>
                    <el-col :span="6">
                        <el-input v-model="search" clearable placeholder="Buscar"
                            @clear="handleCurrentChange(modelName)"
                            @keyup.enter.native="handleCurrentChange(modelName)">
                            <el-button slot="append" :icon="icon" @click="handleCurrentChange(modelName)"></el-button>
                        </el-input>
                    </el-col>
                </div>
                <br>
                <!--Generic Table -->
                <el-table :data="catalogs" border stripe height="450" style="width: 100%"
                    :row-class-name="tableRowClassName">
                    <el-table-column prop="name" sortable :label="label">
                        <template slot-scope="scope">

                            <el-input v-model="scope.row.name" :disabled="scope.row.isActive == false" />
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="isActive" label="Acciones de Edición" width="300">
                        <template slot-scope="scope">
                            <CatsActions :alias_this="alias_this" :method-reload="getCatalog" :cat="scope.row"
                                :label="label"></CatsActions>
                        </template>
                    </el-table-column>
                </el-table>
                <el-tooltip class="item" effect="dark" content="Cerrar o Administrar otro Catálogo" placement="top-end">
                    <el-button type="danger" icon="fas fa-times-circle" align="right" class="buttonFixed"
                        @click="closeTable" round>
                    </el-button>
                </el-tooltip>
            </span>
        </span>
        <!--Table for SubBudget-->
        <span v-if="showSubBudget == true">
            <span v-if="showTable == true && label == 'Sub Partida'">
                <span>
                    <div align="right">
                        <el-button type="success" icon="fas fa-plus" @click="showDialog(label)">
                            Agregar {{ label }}
                        </el-button>
                        <el-col :span="6">
                            <el-input v-model="search" clearable placeholder="Buscar"
                                @clear="handleCurrentChange(modelName)"
                                @keyup.enter.native="handleCurrentChange(modelName)">
                                <el-button slot="append" :icon="icon"
                                    @click="handleCurrentChange(modelName)"></el-button>
                            </el-input>
                        </el-col>
                    </div>
                    <br>
                    <el-table :data="catalogs" border stripe height="450" style="width: 100%"
                        :row-class-name="tableRowClassName">
                        <el-table-column prop="name" sortable :label="label" min-width="120" />
                        <el-table-column prop="code" label="Clave" />
                        <el-table-column prop="budget.name" label="Partida Asociada" />
                        <el-table-column align="center" prop="isActive" label="Acciones de Edición" width="300">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="Editar" placement="top-end">
                                    <el-button type="primary" icon="fas fa-edit" size="small"
                                        @click="subBudgetEdit(scope.row)">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-tooltip class="item" effect="dark" content="Cerrar o Administrar otro Catálogo"
                        placement="top-end">
                        <el-button type="danger" icon="fas fa-times-circle" align="right" class="buttonFixed"
                            @click="closeTable" round>
                        </el-button>
                    </el-tooltip>
                </span>
            </span>

        </span>

        <!--Table for Product-->
        <span v-if="showProducts == true">
            <span v-if="showTable == true && label == 'Productos o Servicios'">
                <span v-if="label == 'Productos o Servicios'">
                    <div align="right">
                        <el-button type="success" icon="fas fa-plus" @click="showDialog(label)">
                            Agregar {{ label }}
                        </el-button>
                        <el-col :span="6">
                            <el-input v-model="search" clearable placeholder="Buscar"
                                @clear="handleCurrentChange(modelName)"
                                @keyup.enter.native="handleCurrentChange(modelName)">
                                <el-button slot="append" :icon="icon"
                                    @click="handleCurrentChange(modelName)"></el-button>
                            </el-input>
                        </el-col>
                    </div>
                    <br>
                    <el-table :data="catalogs" border stripe height="450" style="width: 100%"
                        :row-class-name="tableRowClassName">
                        <el-table-column prop="name" sortable :label="label" />
                        <el-table-column prop="product_or_service.name" label="Tipo" />
                        <el-table-column align="center" prop="isActive" label="Acciones de Edición" width="300">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="Editar" placement="top-end">
                                    <el-button type="primary" icon="fas fa-edit" size="small"
                                        @click="productEdit(scope.row)">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-tooltip class="item" effect="dark" content="Cerrar o Administrar otro Catálogo"
                        placement="top-end">
                        <el-button type="danger" icon="fas fa-times-circle" align="right" class="buttonFixed"
                            @click="closeTable" round>
                        </el-button>
                    </el-tooltip>
                </span>
            </span>
        </span>

        <!--Table for a currencie-->
        <span v-if="showCurrency == true">
            <span v-if="showTable == true && label == 'Moneda'">
                <span v-if="label == 'Moneda'">
                    <div align="right">
                        <el-button type="success" icon="fas fa-plus" @click="showDialog(label)">
                            Agregar {{ label }}
                        </el-button>
                        <el-col :span="6">
                            <el-input v-model="search" clearable placeholder="Buscar"
                                @clear="handleCurrentChange(modelName)"
                                @keyup.enter.native="handleCurrentChange(modelName)">
                                <el-button slot="append" :icon="icon"
                                    @click="handleCurrentChange(modelName)"></el-button>
                            </el-input>
                        </el-col>
                    </div>
                    <br>
                    <el-table :data="catalogs" border stripe height="450" style="width: 100%"
                        :row-class-name="tableRowClassName">
                        <el-table-column prop="name" sortable :label="label" />
                        <el-table-column prop="country.name" label="País" />
                        <el-table-column prop="code" label="Clave" />
                        <el-table-column align="center" prop="isActive" label="Acciones de Edición" width="300">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="Editar" placement="top-end">
                                    <el-button type="primary" icon="fas fa-edit" size="small"
                                        @click="currencyEdit(scope.row)">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-tooltip class="item" effect="dark" content="Cerrar o Administrar otro Catálogo"
                        placement="top-end">
                        <el-button type="danger" icon="fas fa-times-circle" align="right" class="buttonFixed"
                            @click="closeTable" round>
                        </el-button>
                    </el-tooltip>
                </span>
            </span>

        </span>

        <!--Table for a concept-->
        <span v-if="showConcept">
            <span v-if="showTable == true && label == 'Concepto Sub Partida'">
                <span>
                    <div align="right">
                        <el-button type="success" icon="fas fa-plus" @click="showDialog(label)">
                            Agregar {{ label }}
                        </el-button>
                        <el-col :span="6">
                            <el-input v-model="search" clearable placeholder="Buscar"
                                @clear="handleCurrentChange(modelName)"
                                @keyup.enter.native="handleCurrentChange(modelName)">
                                <el-button slot="append" :icon="icon"
                                    @click="handleCurrentChange(modelName)"></el-button>
                            </el-input>
                        </el-col>
                    </div>
                    <br>
                    <el-table :data="catalogs" border stripe height="450" style="width: 100%"
                        :row-class-name="tableRowClassName">
                        <el-table-column prop="name" sortable :label="label" min-width="120" />
                        <el-table-column prop="code" label="Clave" />
                        <el-table-column prop="sub_budget.name" label="Sup Partida" />
                        <el-table-column align="center" prop="isActive" label="Acciones de Edición" width="300">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="Editar" placement="top-end">
                                    <el-button type="primary" icon="fas fa-edit" size="small"
                                        @click="conceptEdit(scope.row)">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-tooltip class="item" effect="dark" content="Cerrar o Administrar otro Catálogo"
                        placement="top-end">
                        <el-button type="danger" icon="fas fa-times-circle" align="right" class="buttonFixed"
                            @click="closeTable" round>
                        </el-button>
                    </el-tooltip>
                </span>
            </span>
        </span>

        <!--Table for Offices-->
        <span v-if="showOffices">
            <span v-if="showTable == true && label == 'Oficina'">
                <div align="right">
                    <el-button type="success" icon="fas fa-plus" @click="showDialog(label)">
                        Agregar {{ label }}
                    </el-button>
                    <el-col :span="6">
                        <el-input v-model="search" clearable placeholder="Buscar"
                            @clear="handleCurrentChange(modelName)"
                            @keyup.enter.native="handleCurrentChange(modelName)">
                            <el-button slot="append" :icon="icon" @click="handleCurrentChange(modelName)"></el-button>
                        </el-input>
                    </el-col>
                </div>
                <br>
                <el-table :data="offices" border stripe height="450" style="width: 100%"
                    :row-class-name="tableRowClassName">
                    <el-table-column type="index" label="#" />
                    <el-table-column prop="representation_name" sortable :label="label" min-width="120" />
                    <el-table-column prop="type.name" label="Tipo" />
                    <el-table-column prop="region.name" label="Región" />
                    <el-table-column prop="country.name" label="País" />
                    <el-table-column prop="state.name" label="Estado" />
                    <el-table-column prop="isHardLife" label="Vida Difícil">
                        <template slot-scope="scope">
                            <span>{{ scope.row.isHardLife == 1 || scope.row.isHardLife == true ? 'Sí' : 'No' }}</span>
                        </template>

                    </el-table-column>
                    <el-table-column align="center" prop="isActive" label="Acciones de Edición" width="300">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="Editar" placement="top-end">
                                <el-button type="primary" icon="fas fa-edit" size="small"
                                    @click="officeEdit(scope.row)">
                                </el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <br>
                <el-pagination @current-change="handleCurrentChange2" :current-page.sync="currentPage"
                    layout="total, ->, prev, pager, next" :total="total">
                </el-pagination>
            </span>

        </span>

        <!--Table for service name-->
        <span v-if="showServiceName">
            <span v-if="label == 'Nombre del Servicio'">
                <div align="right">
                    <el-button type="success" icon="fas fa-plus" @click="showDialog(label)">
                        Agregar {{ label }}
                    </el-button>
                    <el-col :span="6">
                        <el-input v-model="search" clearable placeholder="Buscar"
                            @clear="handleCurrentChange(modelName)"
                            @keyup.enter.native="handleCurrentChange(modelName)">
                            <el-button slot="append" :icon="icon" @click="handleCurrentChange(modelName)"></el-button>
                        </el-input>
                    </el-col>
                </div>
                <br>
                <el-table :data="catalogs" border stripe height="450" style="width: 100%"
                    :row-class-name="tableRowClassName">
                    <el-table-column prop="name" sortable :label="label" />
                    <el-table-column prop="type.name" label="Tipo" />
                    <el-table-column align="center" prop="isActive" label="Acciones de Edición" width="300">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="Editar" placement="top-end">
                                <el-button type="primary" icon="fas fa-edit" size="small"
                                    @click="serviceEdit(scope.row)">
                                </el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <el-tooltip class="item" effect="dark" content="Cerrar o Administrar otro Catálogo" placement="top-end">
                    <el-button type="danger" icon="fas fa-times-circle" align="right" class="buttonFixed"
                        @click="closeTable" round>
                    </el-button>
                </el-tooltip>
            </span>

        </span>

        <!--Table for Regions-->
        <span v-if="showRegions">
            <span v-if="showTable == true && label == 'Regiones'">
                <div align="right">
                    <el-button type="success" icon="fas fa-plus" @click="showDialog(label)">
                        Agregar {{ label }}
                    </el-button>
                    <el-col :span="6">
                        <el-input v-model="search" clearable placeholder="Buscar"
                            @clear="handleCurrentChange(modelName)"
                            @keyup.enter.native="handleCurrentChange(modelName)">
                            <el-button slot="append" :icon="icon" @click="handleCurrentChange(modelName)" />
                        </el-input>
                    </el-col>
                </div>
                <br>
                <el-table :data="regions" border stripe height="450" style="width: 100%"
                    :row-class-name="tableRowClassName">
                    <el-table-column type="index" label="#" />
                    <el-table-column prop="name" sortable :label="label" min-width="120" />
                    <el-table-column align="center" prop="isActive" label="Acciones de Edición" width="300">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="Editar" placement="top-end">
                                <el-button type="primary" icon="fas fa-edit" size="small"
                                    @click="regionEdit(scope.row)" />
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <br>
                <el-pagination @current-change="handleCurrentChange2" :current-page.sync="currentPage"
                    layout="total, ->, prev, pager, next" :total="total">
                </el-pagination>
            </span>
        </span>

        <!--Message if the selected catalog is not-->
        <div class="tip" v-if="!showTable">
            <h6 align="center">Seleccione un catálogo de la lista para ser administrado. </h6>
        </div>

        <!--Dialog for add new generic Field-->
        <el-dialog :title="'Agregar ' + label" :visible.sync="addNew">
            <el-form @submit.native.prevent ref="genericForm" :model="genericForm" label-width="120px"
                label-position="top">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item :label="label" prop="name"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="genericForm.name">
                                <el-button slot="append" icon="el-icon-search"
                                    @click.prevent="checkField(genericForm.name)"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" icon="fas fa-times" @click="addNew = false">
                    Cancelar
                </el-button>
                <el-button type="primary" icon="fas fa-save" :disabled="!isFieldValid" @click="saveNewField(modelName)">
                    Guardar
                </el-button>
            </span>
        </el-dialog>

        <!--Dialog for add a new SubBudget-->
        <el-dialog :title="'Agregar ' + label" :visible.sync="addSubBudget">
            <el-form @submit.native.prevent ref="subBudgetForm" :model="subBudgetForm" label-width="120px"
                label-position="top">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="label" prop="name"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="subBudgetForm.name">
                                <el-button slot="append" icon="el-icon-search"
                                    @click.prevent="checkField(subBudgetForm.name)"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Clave" prop="code"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="subBudgetForm.code" :disabled="!isFieldValid" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Partida"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="subBudgetForm.cat_budget_id" style="width: 100%" filterable clearable
                                :disabled="!isFieldValid" placeholder="Seleccionar">
                                <el-option v-for="item in budgets" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" icon="fas fa-times" @click="addSubBudget = false">
                    Cancelar
                </el-button>
                <el-button type="primary" icon="fas fa-save" :disabled="!isFieldValid" @click="saveNewField(modelName)">
                    Guardar
                </el-button>
            </span>
        </el-dialog>

        <!--Dialog for edit SubBudget-->
        <el-dialog title="Edición de Sub Partida" :visible.sync="modalSubBudget">
            <el-form @submit.native.prevent ref="register" :model="register" label-width="120px" label-position="top">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="label" prop="name"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="register.name" :disabled="register.isActive == false" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Clave" prop="code"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="register.code" :disabled="register.isActive == false" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Partida" prop="cat_budget_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="register.cat_budget_id" style="width: 100%" filterable clearable
                                :disabled="register.isActive == false" placeholder="Seleccionar">
                                <el-option v-for="item in budgets" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-row :gutter="20">
                    <CatsActions aliasRef="register" :alias_this="alias_this" :methodReload="getCatalog"
                        :cat="register">
                    </CatsActions>
                </el-row>
            </span>
        </el-dialog>

        <!--Dialog for add a new concept-->
        <el-dialog :title="'Agregar ' + label" :visible.sync="addConcept">
            <el-form @submit.native.prevent ref="conceptForm" :model="conceptForm" label-width="120px"
                label-position="top">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="label" prop="name"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="conceptForm.name">
                                <el-button slot="append" icon="el-icon-search"
                                    @click.prevent="checkField(conceptForm.name)"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Clave" prop="code"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="conceptForm.code" :disabled="!isFieldValid" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Sub Partida" prop="cat_sub_budget_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="conceptForm.cat_sub_budget_id" style="width: 100%" filterable clearable
                                :disabled="!isFieldValid" placeholder="Seleccionar">
                                <el-option v-for="item in subBudgets" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" icon="fas fa-times" @click="addConcept = false">
                    Cancelar
                </el-button>
                <el-button type="primary" icon="fas fa-save" :disabled="!isFieldValid" @click="saveNewField(modelName)">
                    Guardar
                </el-button>
            </span>
        </el-dialog>

        <!--Dialog for edit concept-->
        <el-dialog title="Edición de Sub Partida" :visible.sync="modalConcept">
            <el-form @submit.native.prevent ref="register" :model="register" label-width="120px" label-position="top">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="label" prop="name"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="register.name" :disabled="register.isActive == false" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Clave" prop="code"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="register.code" :disabled="register.isActive == false" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Sub Partida" prop="cat_sub_budget_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="register.cat_sub_budget_id" style="width: 100%" filterable clearable
                                :disabled="register.isActive == false" placeholder="Seleccionar">
                                <el-option v-for="item in subBudgets" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-row :gutter="20">
                    <CatsActions aliasRef="register" :alias_this="alias_this" :methodReload="getCatalog"
                        :cat="register">
                    </CatsActions>
                </el-row>
            </span>
        </el-dialog>

        <!--Dialog for add new ProductOrService-->
        <el-dialog :title="'Agregar ' + label" :visible.sync="addProduct">
            <el-form @submit.native.prevent ref="productForm" :model="productForm" label-width="120px"
                label-position="top">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item :label="label" prop="name"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="productForm.name">
                                <el-button slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Tipo" prop="type_product_or_service_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="productForm.type_product_or_service_id" style="width: 100%" filterable
                                clearable placeholder="Seleccionar">
                                <el-option v-for="item in typesProductOrServices" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" icon="fas fa-times" @click="addProduct = false">
                    Cancelar
                </el-button>
                <el-button type="primary" icon="fas fa-save" @click="saveNewField(modelName)">
                    Guardar
                </el-button>
            </span>
        </el-dialog>

        <!--Dialog for edit ProductOrService-->
        <el-dialog :title="'Agregar ' + label" :visible.sync="modalProduct">
            <el-form @submit.native.prevent ref="register" :model="register" label-width="120px" label-position="top">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item :label="label" prop="name"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="register.name" :disabled="register.name == 'Otros'" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Tipo" porp="type_product_or_service_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="register.type_product_or_service_id" style="width: 100%" filterable
                                clearable :disabled="register.isActive == false" placeholder="Seleccionar">
                                <el-option v-for="item in typesProductOrServices" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-row :gutter="20">
                    <CatsActions aliasRef="register" :alias_this="alias_this" :methodReload="getCatalog"
                        :cat="register">
                    </CatsActions>
                </el-row>
            </span>
        </el-dialog>

        <!--Dialog for addCurrency-->
        <el-dialog :title="'Agregar ' + label" :visible.sync="addCurrency">
            <el-form @submit.native.prevent ref="currencyForm" :model="currencyForm" label-width="120px"
                label-position="top">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="label" prop="name"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="currencyForm.name">
                                <el-button slot="append" icon="el-icon-search"
                                    @click.prevent="checkField(currencyForm.name)"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Clave" prop="code"
                            :rules="{ validator: checkDeterminant, trigger: ['blur', 'change'] }">
                            <el-input maxlength="3" v-model="currencyForm.code" :disabled="!isFieldValid" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="País" prop="cat_country_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="currencyForm.cat_country_id" style="width: 100%" filterable clearable
                                :disabled="!isFieldValid" placeholder="Seleccionar">
                                <el-option v-for="item in countries" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" icon="fas fa-times" @click="addCurrency = false">
                    Cancelar
                </el-button>
                <el-button type="primary" icon="fas fa-save" :disabled="!isFieldValid" @click="saveNewField(modelName)">
                    Guardar
                </el-button>
            </span>
        </el-dialog>

        <!--Dialog for editCurrency-->
        <el-dialog :title="'Agregar ' + label" :visible.sync="modalCurrency">
            <el-form @submit.native.prevent ref="register" :model="register" label-width="120px" label-position="top">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="label" prop="name"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="register.name" :disabled="register.isActive == false" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Clave" prop="code"
                            :rules="{ validator: checkDeterminant, trigger: ['blur', 'change'] }">
                            <el-input maxlength="3" v-model="register.code" :disabled="register.isActive == false" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="País" prop="cat_country_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select :disabled="register.isActive == false" v-model="register.cat_country_id"
                                style="width: 100%" filterable clearable placeholder="Seleccionar">
                                <el-option v-for="item in countries" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-row :gutter="20">
                    <CatsActions aliasRef="register" :alias_this="alias_this" :methodReload="getCatalog"
                        :cat="register">
                    </CatsActions>
                </el-row>
            </span>
        </el-dialog>

        <!--Dialog for add Office-->
        <el-dialog :title="'Agregar ' + label" :visible.sync="addOffice" :fullscreen="true">
            <el-form @submit.native.prevent ref="officeForm" :model="officeForm" label-width="120px"
                label-position="top">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="label" prop="location"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="officeForm.location" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="Región" prop="cat_region_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="officeForm.cat_region_id" style="width: 100%" filterable clearable
                                placeholder="Seleccionar">
                                <el-option v-for="item in regions" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="País" prop="cat_country_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="officeForm.cat_country_id" style="width: 100%"
                                @change="officeForm.cat_state_id = ''" filterable clearable placeholder="Seleccionar">
                                <el-option v-for="item in countries" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="Estado" prop="cat_state_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="officeForm.cat_state_id" style="width: 100%" filterable clearable
                                placeholder="Seleccionar">
                                <el-option v-for="item in filterStates(states, officeForm.cat_country_id, 1)"
                                    :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Tipo" prop="cat_type_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="officeForm.cat_type_id" style="width: 100%" filterable clearable
                                placeholder="Seleccionar">
                                <el-option v-for="item in typeOffices" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="" prop="isHardLife">
                            <el-checkbox style="margin-top: 53px;width: 100%;" v-model="officeForm.isHardLife"
                                label="Vida Difícil" border />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-card shadow="never">
                            <div slot="header">
                                <span>Informático Responsable</span>
                            </div>
                            <div class="tip">
                                <span>Para agregar Informáticos Responsables escriba sobre las opciones</span>
                            </div>
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <el-form-item label="Usuarios" pro="users">
                                        <el-select v-model="officeForm.users" style="width: 100%"
                                            no-data-text="Es necesario realizar una búsqueda" filterable clearable
                                            multiple="" placeholder="Seleccionar" remote reserve-keyword
                                            :remote-method="handleCurrentChangeUsers" :loading="loading">
                                            <el-option v-for="item in users" :key="item.id"
                                                :label="item.full_name + ' / ' + item.username" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" icon="fas fa-times" @click="addOffice = false">
                    Cancelar
                </el-button>
                <el-button type="primary" icon="fas fa-save" @click="saveNewField(modelName)">
                    Guardar
                </el-button>
            </span>
        </el-dialog>

        <!--Dialog for edit Office-->
        <el-dialog :title="'Agregar ' + label" :visible.sync="modalOffice" :fullscreen="true">
            <el-form @submit.native.prevent ref="register" :model="register" label-width="120px" label-position="top">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="label" prop="location"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="register.location" :disabled="!register.isActive" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Región" prop="cat_region_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="register.cat_region_id" style="width: 100%" :disabled="!register.isActive"
                                filterable clearable placeholder="Seleccionar">
                                <el-option v-for="item in regions" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="País" prop="cat_country_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="register.cat_country_id" style="width: 100%"
                                :disabled="!register.isActive" @change="register.cat_state_id = ''" filterable clearable
                                placeholder="Seleccionar">
                                <el-option v-for="item in countries" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="Estado" prop="cat_state_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="register.cat_state_id" style="width: 100%"
                                :disabled="!register.isActive" filterable clearable placeholder="Seleccionar">
                                <el-option v-for="item in filterStates(states, register.cat_country_id, 2)"
                                    :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Tipo" prop="cat_type_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="register.cat_type_id" style="width: 100%" :disabled="!register.isActive"
                                filterable clearable placeholder="Seleccionar">
                                <el-option v-for="item in typeOffices" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="" prop="isHardLife">
                            <el-checkbox :disabled="!register.isActive" style="margin-top: 53px;width: 100%;"
                                v-model="register.isHardLife" label="Vida Difícil" border />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-card shadow="never">
                            <div slot="header">
                                <span>Informático Responsable</span>
                            </div>
                            <div class="tip">
                                <span>Para agregar Informáticos Responsables escriba sobre las opciones</span>
                            </div>
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <el-form-item label="Usuarios" pro="users_ids">
                                        <el-select v-model="register.users_ids" style="width: 100%"
                                            no-data-text="Es necesario realizar una búsqueda" filterable clearable
                                            multiple="" placeholder="Seleccionar" remote :disabled="!register.isActive"
                                            reserve-keyword :remote-method="handleCurrentChangeUsers"
                                            :loading="loading">
                                            <el-option v-for="item in users" :key="item.id"
                                                :label="item.full_name + ' / ' + item.username" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                            </el-row>



                        </el-card>
                    </el-col>

                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-row :gutter="20">
                    <CatsActions aliasRef="register" :alias_this="alias_this" :methodReload="getCatalog"
                        :cat="register">
                    </CatsActions>
                </el-row>
            </span>
        </el-dialog>

        <!--Dialog for add new Service Name-->
        <el-dialog :title="'Agregar ' + label" :visible.sync="addService">
            <el-form @submit.native.prevent ref="serviceForm" :model="serviceForm" label-width="120px"
                label-position="top">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item :label="label" prop="name"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="serviceForm.name">
                                <el-button slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Tipo" prop="type_service_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="serviceForm.type_service_id" style="width: 100%" filterable clearable
                                placeholder="Seleccionar">
                                <el-option v-for="item in typeAcquisition" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" icon="fas fa-times" @click="addService = false">
                    Cancelar
                </el-button>
                <el-button type="primary" icon="fas fa-save" @click="saveNewField(modelName)">
                    Guardar
                </el-button>
            </span>
        </el-dialog>

        <!--Dialog for edit Service Name-->
        <el-dialog :title="'Agregar ' + label" :visible.sync="modalService">
            <el-form @submit.native.prevent ref="register" :model="register" label-width="120px" label-position="top">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item :label="label" prop="name"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="register.name" :disabled="register.name == 'Otros'" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Tipo" porp="type_service_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="register.type_service_id" style="width: 100%" filterable clearable
                                :disabled="register.isActive == false" placeholder="Seleccionar">
                                <el-option v-for="item in typeAcquisition" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-row :gutter="20">
                    <CatsActions aliasRef="register" :alias_this="alias_this" :methodReload="getCatalog"
                        :cat="register">
                    </CatsActions>
                </el-row>
            </span>
        </el-dialog>

        <!--Dialog for add new Region-->
        <el-dialog :title="'Agregar ' + label" :visible.sync="addRegion">
            <el-form @submit.native.prevent ref="regionForm" :model="regionForm" label-width="120px"
                label-position="top">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="Nombre de la región" prop="name"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="regionForm.name" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" icon="fas fa-times" @click="addRegion = false">
                    Cancelar
                </el-button>
                <el-button type="primary" icon="fas fa-save" @click="saveNewField(modelName)">
                    Guardar
                </el-button>
            </span>
        </el-dialog>

        <!--Dialog for edit REgion-->
        <el-dialog :title="'Editar ' + label" :visible.sync="modalRegion">
            <el-form @submit.native.prevent ref="register" :model="register" label-width="120px" label-position="top">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="Nombre de la región" prop="name"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="register.name" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <CatsActions aliasRef="register" :alias_this="alias_this" :methodReload="getCatalog" :cat="register">
                </CatsActions>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import CatsActions from '../partials/CatsActions';

export default {
    components: { CatsActions },
    data() {
        return {
            cats: [],
            selectCat: [],
            catalogs: [],
            offices: [],
            regions: [],
            budgets: [],
            subBudgets: [],
            states: [],
            typeOffices: [],
            users: [],
            typeAcquisition: [],
            register: {},
            modelName: '',
            icon: 'el-icon-search',
            search: '',
            showTable: false,
            showGeneric: false,
            showSubBudget: false,
            showProducts: false,
            showCurrency: false,
            modalSubBudget: false,
            addProduct: false,
            label: '',
            addNew: false,
            isFieldValid: false,
            modalProduct: false,
            addCurrency: false,
            modalCurrency: false,
            showConcept: false,
            modalConcept: false,
            addConcept: false,
            showOffices: false,
            addOffice: false,
            modalOffice: false,

            showRegions: false,
            addRegion: false,
            modalRegion: false,

            loading: false,
            showServiceName: false,
            addService: false,
            modalService: false,

            currencyForm: {
                name: '',
                code: '',
                cat_country_id: '',
                isActive: 1,

            },
            genericForm: {
                name: '',
                isActive: 1,
            },

            addSubBudget: false,

            subBudgetForm: {
                name: '',
                code: '',
                cat_budget_id: ''
            },
            productForm: {
                name: '',
                type_product_or_service_id: ''
            },
            serviceForm: {
                name: '',
                type_service_id: ''
            },

            subBudgetConceptForm: {
                name: '',
                code: '',
                cat_sub_budget_id: '',
            },

            conceptForm: {
                name: '',
                code: '',
                cat_sub_budget_id: '',
            },

            officeForm: {
                cat_type_id: '',
                cat_region_id: '',
                location: '',
                region: '',
                cat_state_id: '',
                cat_country_id: '',
                isHardLife: false,
                users: [],
            },

            regionForm: {
                name: '',
            },

            typesProductOrServices: [],
            countries: [],
            currentPage: 1,
            perPage: 10,
            total: 0,
            page: 1,
        }
    },

    created() {
        axios.get('/api/catalogs').then(response => {
            this.cats = response.data.cat;
        }).catch(error => {
            this.$store.dispatch('loading/spinner', {}, { root: true });
            this.$store.dispatch('notifications/error',
                { msg: 'No fue posible mostrar información de catálogo o no cuenta con autorización.' },
                { root: true });
        });
    },

    computed: {

        alias_this() {
            return this;
        },
    },

    watch: {
        'register.isHardLife'(value) {
            if (value == 1 || value == true) {
                return this.register.isHardLife = true
            } else {
                return false
            }
        }
    },

    methods: {

        showLoading() {
            this.$store.dispatch('loading/spinner', { msg: 'Cargando Datos...', status: true }, { root: true });
        },

        hideLoading() {
            this.$store.dispatch('loading/spinner', {}, { root: true });
        },

        handleCurrentChange(modelName) {
            this.getCatalog(modelName);
        },

        handleCurrentChangeUsers(search) {
            if (search != '') {
                let params = {
                    search: search,
                };
                this.showLoading();
                axios.get('/api/search-informatic', { params }).then(response => {
                    if (response.data.success) {
                        this.users = response.data.users;
                        search = '';
                    }
                    this.hideLoading();
                }).catch(error => {
                    this.$store.dispatch('loading/spinner', {}, { root: true });
                    this.$store.dispatch('notifications/error',
                        { msg: 'No fue posible mostrar información o no cuenta con autorización.' },
                        { root: true });
                });
            } else {
                search = '';
                this.users = []
            }
        },


        getCatalog(model_name) {
            let params = {
                catalog: model_name,
                page: this.currentPage,
                perPage: this.perPage,
                search: this.search
            };
            this.showLoading();
            axios.get('/api/catalogs/create', { params }).then(response => {

                if (model_name != 'App\\Http\\Models\\Cats\\CatOffice' && response.data.success) {
                    this.catalogs = response.data.catalog;
                }
                if (response.data.budgets) {
                    this.budgets = response.data.budgets;
                }
                if (response.data.productOrService) {
                    this.typesProductOrServices = response.data.productOrService;
                }
                if (response.data.countries) {
                    this.countries = response.data.countries;
                }

                if (response.data.subBudgets) {
                    this.subBudgets = response.data.subBudgets;
                }
                if (response.data.states) {
                    this.states = response.data.states;
                }
                if (response.data.typeOffices) {
                    this.typeOffices = response.data.typeOffices;
                }
                if (response.data.typeAcquisition) {
                    this.typeAcquisition = response.data.typeAcquisition;
                }

                if (response.data.regions && response.data.success) {
                    this.regions = response.data.regions;
                }

                if (model_name == 'App\\Http\\Models\\Cats\\CatOffice') {

                    this.modelName = 'App\\Http\\Models\\Cats\\CatOffice';
                    this.offices = response.data.catalog.data;
                    this.total = response.data.catalog.total;
                    this.perPage = response.data.catalog.per_page;
                    this.label = 'Oficina';
                    this.showTable = true;
                    this.showOffices = true;

                }
                this.hideLoading();
            }).catch(error => {
                this.$store.dispatch('loading/spinner', {}, { root: true });
                this.$store.dispatch('notifications/error',
                    { msg: 'No fue posible mostrar información de catálogo o no cuenta con autorización.' },
                    { root: true });
            });

            if (model_name == 'App\\Http\\Models\\Cats\\CatAcquisitionStatus') {
                this.label = 'Estatus';
                this.modelName = 'App\\Http\\Models\\Cats\\CatAcquisitionStatus';
                this.showTable = true;
                this.showGeneric = true;

            }
            if (model_name == 'App\\Http\\Models\\Cats\\CatAcquisitionType') {
                this.label = 'Tipo de Adquisición';
                this.modelName = 'App\\Http\\Models\\Cats\\CatAcquisitionType';
                this.showTable = true;
                this.showGeneric = true;

            }
            if (model_name == 'App\\Http\\Models\\Cats\\ServiceName') {
                this.label = 'Nombre del Servicio';
                this.modelName = 'App\\Http\\Models\\Cats\\ServiceName';
                this.showTable = true;
                this.showServiceName = true;

            }
            if (model_name == 'App\\Http\\Models\\Cats\\CatAgreementMultiyear') {
                this.label = 'Tipos de contratación';
                this.modelName = 'App\\Http\\Models\\Cats\\CatAgreementMultiyear';
                this.showTable = true;
                this.showGeneric = true;

            }
            if (model_name == 'App\\Http\\Models\\Cats\\CatAgreementType') {
                this.label = 'Tipos de acuerdo';
                this.modelName = 'App\\Http\\Models\\Cats\\CatAgreementType';
                this.showTable = true;
                this.showGeneric = true;

            }
            if (model_name == 'App\\Http\\Models\\Cats\\CatBudget') {
                this.label = 'Partidas';
                this.modelName = 'App\\Http\\Models\\Cats\\CatBudget';
                this.showTable = true;
                this.showGeneric = true;

            }
            if (model_name == 'App\\Http\\Models\\Cats\\CatCurrency') {
                this.label = 'Moneda';
                this.modelName = 'App\\Http\\Models\\Cats\\CatCurrency';
                this.showTable = true;
                this.showCurrency = true;

            }
            if (model_name == 'App\\Http\\Models\\Cats\\CatIsThereBudget') {
                this.label = 'Presupuesto';
                this.modelName = 'App\\Http\\Models\\Cats\\CatIsThereBudget';
                this.showTable = true;
                this.showGeneric = true;

            }
            if (model_name == 'App\\Http\\Models\\Cats\\CatOfficeType') {
                this.label = 'Tipo de Oficina';
                this.modelName = 'App\\Http\\Models\\Cats\\CatOfficeType';
                this.showTable = true;
                this.showGeneric = true;

            }
            if (model_name == 'App\\Http\\Models\\Cats\\CatRepresentationType') {
                this.label = 'Tipo de Representación';
                this.modelName = 'App\\Http\\Models\\Cats\\CatRepresentationType';
                this.showTable = true;
                this.showGeneric = true;

            }
            if (model_name == 'App\\Http\\Models\\Cats\\CatEquipmentType') {
                this.label = 'Tipo de Equipo';
                this.modelName = 'App\\Http\\Models\\Cats\\CatEquipmentType';
                this.showTable = true;
                this.showGeneric = true;

            }
            if (model_name == 'App\\Http\\Models\\Cats\\CatSubBudget') {
                this.label = 'Sub Partida';
                this.modelName = 'App\\Http\\Models\\Cats\\CatSubBudget';
                this.showSubBudget = true;
                this.showTable = true;

            }
            if (model_name == 'App\\Http\\Models\\Cats\\CatProductsOrServicesArticles') {
                this.label = 'Productos o Servicios';
                this.modelName = 'App\\Http\\Models\\Cats\\CatProductsOrServicesArticles';
                this.showProducts = true;
                this.showTable = true;

            }

            if (model_name == 'App\\Http\\Models\\Cats\\CatConceptSubBudget') {
                this.label = 'Concepto Sub Partida';
                this.modelName = 'App\\Http\\Models\\Cats\\CatConceptSubBudget';
                this.showConcept = true;
                this.showTable = true;

            }

            if (model_name == 'App\\Http\\Models\\Cats\\CatRegion') {
                this.label = 'Regiones';
                this.modelName = 'App\\Http\\Models\\Cats\\CatRegion';
                this.showRegions = true;
                this.showTable = true;
            }
        },

        showDialog(label) {
            if (label == 'Estatus' || label == 'Tipo de Adquisición' || label == 'Tipos de contratación'
                || label == 'Tipos de acuerdo' || label == 'Partidas' || label == 'Presupuesto'
                || label == 'Tipo de Oficina' || label == 'Tipo de Representación') {

                this.addNew = true;
                this.genericForm.name = '';
                this.isFieldValid = false;
            }
            else if (label == 'Sub Partida') {
                this.addSubBudget = true;
                this.subBudgetForm.name = '';
                this.subBudgetForm.cat_budget_id = '';
                this.isFieldValid = false;

            } else if (label == 'Productos o Servicios') {
                this.addProduct = true;
                this.productForm.name = '';
                this.productForm.type_product_or_service_id = '';
                this.isFieldValid = false;

            } else if (label == 'Moneda') {
                this.addCurrency = true;
                this.currencyForm.name = '';
                this.currencyForm.code = '';
                this.currencyForm.cat_country_id = '';
                this.isFieldValid = false;
            } else if (label == 'Concepto Sub Partida') {
                this.addConcept = true;
                this.conceptForm.name = '';
                this.conceptForm.code = '';
                this.conceptForm.cat_sub_budget_id = '';
                this.isFieldValid = false;
            } else if (label == 'Oficina') {
                this.addOffice = true;
                this.officeForm.cat_type_id = '';
                this.officeForm.cat_region_id = '';
                this.officeForm.location = '';
                this.officeForm.cat_state_id = '';
                this.officeForm.cat_country_id = '';
                this.officeForm.isHardLife = false;
                this.isFieldValid = false;
                this.officeForm.users = []
            }
            else if (label == 'Nombre del Servicio') {
                this.addService = true;
                this.serviceForm.type_service_id = '';
                this.serviceForm.name = '';
                this.isFieldValid = false;
            }
            else if (label == 'Regiones') {
                this.addRegion = true;
                this.regionForm.name = '';
                this.isFieldValid = false;
            }

        },


        checkField(field) {
            this.showLoading();
            if (field != '') {
                axios.post('/api/check-field', {
                    field: field,
                    catalog: this.modelName
                }).then(response => {
                    this.$store.dispatch('notifications/ok', { msg: response.data.message }, { root: true });
                    this.isFieldValid = true;
                    this.hideLoading();

                }).catch(error => {
                    this.$store.dispatch('notifications/error', { msg: 'El campo que ingresó ya existe en el catálogo, favor de verificar.' }, { root: true });

                    this.isFieldValid = false;
                    this.hideLoading();
                });
            } else {
                this.$store.dispatch('notifications/error', { msg: 'Completar los campos requeridos.' }, { root: true });
                this.hideLoading();
            }
            this.hideLoading();
        },

        saveNewField(catalog) {

            if (catalog == 'App\\Http\\Models\\Cats\\CatAcquisitionStatus'
                || catalog == 'App\\Http\\Models\\Cats\\CatAcquisitionType'
                || catalog == 'App\\Http\\Models\\Cats\\CatAgreementMultiyear'
                || catalog == 'App\\Http\\Models\\Cats\\CatAgreementType'
                || catalog == 'App\\Http\\Models\\Cats\\CatBudget'
                || catalog == 'App\\Http\\Models\\Cats\\CatIsThereBudget'
                || catalog == 'App\\Http\\Models\\Cats\\CatOfficeType'
                || catalog == 'App\\Http\\Models\\Cats\\CatRepresentationType'
                || catalog == 'App\\Http\\Models\\Cats\\CatEquipmentType'
            ) {
                this.$refs['genericForm'].validate((valid) => {
                    if (valid) {
                        let data = {
                            catalog: catalog,
                            form: this.genericForm
                        };
                        axios.post('/api/catalogs', data).then(response => {
                            this.showLoading();
                            let _response = response.data.success;

                            if (_response) {
                                this.getCatalog(catalog);
                                this.addNew = false;
                                this.$store.dispatch('notifications/ok',
                                    { msg: 'Se agregó un nuevo campo en catálogo' },
                                    { root: true });

                            }
                            else {
                                this.$store.dispatch('notifications/error',
                                    { msg: 'Error al agregar' },
                                    { root: true });
                            }
                            this.hideLoading();
                        }).catch(error => {
                            this.hideLoading();
                            this.$store.dispatch('notifications/error',
                                { msg: 'No fue posible agregar rubro' },
                                { root: true });
                        });
                    } else {
                        this.$store.dispatch('loading/spinner', {}, { root: true });
                        this.$store.dispatch('notifications/warning',
                            { msg: 'Por favor complete todos los campos requeridos' },
                            { root: true });
                        this.hideLoading();
                        return false;
                    }
                });

            } else if (catalog == 'App\\Http\\Models\\Cats\\CatSubBudget') {
                this.$refs['subBudgetForm'].validate((valid) => {
                    if (valid) {
                        let data = {
                            catalog: catalog,
                            form: this.subBudgetForm
                        };
                        axios.post('/api/catalogs', data).then(response => {
                            this.showLoading();
                            let _response = response.data.success;

                            if (_response) {
                                this.getCatalog(catalog);
                                this.addSubBudget = false;
                                this.$store.dispatch('notifications/ok',
                                    { msg: 'Se agregó un nuevo campo en catálogo' },
                                    { root: true });

                            }
                            else {
                                this.$store.dispatch('notifications/error',
                                    { msg: 'Error al agregar' },
                                    { root: true });
                            }
                            this.hideLoading();
                        }).catch(error => {
                            this.hideLoading();
                            this.$store.dispatch('notifications/error',
                                { msg: 'No fue posible agregar rubro' },
                                { root: true });
                        });
                    } else {
                        this.$store.dispatch('loading/spinner', {}, { root: true });
                        this.$store.dispatch('notifications/warning',
                            { msg: 'Por favor complete todos los campos requeridos' },
                            { root: true });
                        this.hideLoading();
                        return false;
                    }
                });
            } else if (catalog == 'App\\Http\\Models\\Cats\\CatProductsOrServicesArticles') {
                this.$refs['productForm'].validate((valid) => {
                    if (valid) {
                        let data = {
                            catalog: catalog,
                            form: this.productForm
                        };
                        axios.post('/api/catalogs', data).then(response => {
                            this.showLoading();
                            let _response = response.data.success;

                            if (_response) {
                                this.getCatalog(catalog);
                                this.addProduct = false;
                                this.$store.dispatch('notifications/ok',
                                    { msg: 'Se agregó un nuevo campo en catálogo' },
                                    { root: true });

                            }
                            else {
                                this.$store.dispatch('notifications/error',
                                    { msg: response.data.message },
                                    { root: true });
                            }
                            this.hideLoading();
                        }).catch(error => {
                            this.hideLoading();
                            this.$store.dispatch('notifications/error',
                                { msg: 'No fue posible agregar rubro' },
                                { root: true });
                        });
                    } else {
                        this.$store.dispatch('loading/spinner', {}, { root: true });
                        this.$store.dispatch('notifications/warning',
                            { msg: 'Por favor complete todos los campos requeridos' },
                            { root: true });
                        this.hideLoading();
                        return false;
                    }
                });
            } else if (catalog == 'App\\Http\\Models\\Cats\\CatCurrency') {
                this.$refs['currencyForm'].validate((valid) => {
                    if (valid) {
                        let data = {
                            catalog: catalog,
                            form: this.currencyForm
                        };
                        axios.post('/api/catalogs', data).then(response => {
                            this.showLoading();
                            let _response = response.data.success;

                            if (_response) {
                                this.getCatalog(catalog);
                                this.addCurrency = false;
                                this.$store.dispatch('notifications/ok',
                                    { msg: 'Se agregó un nuevo campo en catálogo' },
                                    { root: true });

                            }
                            else {
                                this.$store.dispatch('notifications/error',
                                    { msg: 'Error al agregar' },
                                    { root: true });
                            }
                            this.hideLoading();
                        }).catch(error => {
                            this.hideLoading();
                            this.$store.dispatch('notifications/error',
                                { msg: 'No fue posible agregar rubro' },
                                { root: true });
                        });
                    } else {
                        this.$store.dispatch('loading/spinner', {}, { root: true });
                        this.$store.dispatch('notifications/warning',
                            { msg: 'Por favor complete todos los campos requeridos' },
                            { root: true });
                        this.hideLoading();
                        return false;
                    }
                });
            } else if (catalog == 'App\\Http\\Models\\Cats\\CatConceptSubBudget') {
                this.$refs['conceptForm'].validate((valid) => {
                    if (valid) {
                        let data = {
                            catalog: catalog,
                            form: this.conceptForm
                        };
                        axios.post('/api/catalogs', data).then(response => {
                            this.showLoading();
                            let _response = response.data.success;

                            if (_response) {
                                this.getCatalog(catalog);
                                this.addConcept = false;
                                this.$store.dispatch('notifications/ok',
                                    { msg: 'Se agregó un nuevo campo en catálogo' },
                                    { root: true });

                            }
                            else {
                                this.$store.dispatch('notifications/error',
                                    { msg: 'Error al agregar' },
                                    { root: true });
                            }
                            this.hideLoading();
                        }).catch(error => {
                            this.hideLoading();
                            this.$store.dispatch('notifications/error',
                                { msg: 'No fue posible agregar rubro' },
                                { root: true });
                        });
                    } else {
                        this.$store.dispatch('loading/spinner', {}, { root: true });
                        this.$store.dispatch('notifications/warning',
                            { msg: 'Por favor complete todos los campos requeridos' },
                            { root: true });
                        this.hideLoading();
                        return false;
                    }
                });
            } else if (catalog == 'App\\Http\\Models\\Cats\\CatOffice') {
                this.$refs['officeForm'].validate((valid) => {
                    if (valid) {
                        let data = {
                            catalog: catalog,
                            form: this.officeForm
                        };
                        axios.post('/api/catalogs', data).then(response => {
                            this.showLoading();
                            let _response = response.data.success;

                            if (_response) {
                                this.getCatalog(catalog);
                                this.addOffice = false;
                                this.$store.dispatch('notifications/ok',
                                    { msg: 'Se agregó un nuevo campo en catálogo' },
                                    { root: true });

                            }
                            else {
                                this.$store.dispatch('notifications/error',
                                    { msg: 'Error al agregar' },
                                    { root: true });
                            }
                            this.hideLoading();
                        }).catch(error => {
                            this.hideLoading();
                            this.$store.dispatch('notifications/error',
                                { msg: 'Ya existe una oficina con información similar, verifique y trate nuevamente.' },
                                { root: true });
                        });
                    } else {
                        this.$store.dispatch('loading/spinner', {}, { root: true });
                        this.$store.dispatch('notifications/warning',
                            { msg: 'Por favor complete todos los campos requeridos' },
                            { root: true });
                        this.hideLoading();
                        return false;
                    }
                });
            } else if (catalog == 'App\\Http\\Models\\Cats\\ServiceName') {
                this.$refs['serviceForm'].validate((valid) => {
                    if (valid) {
                        let data = {
                            catalog: catalog,
                            form: this.serviceForm
                        };
                        axios.post('/api/catalogs', data).then(response => {
                            this.showLoading();
                            let _response = response.data.success;

                            if (_response) {
                                this.getCatalog(catalog);
                                this.addService = false;
                                this.$store.dispatch('notifications/ok',
                                    { msg: 'Se agregó un nuevo campo en catálogo' },
                                    { root: true });

                            }
                            else {
                                this.$store.dispatch('notifications/error',
                                    { msg: response.data.message },
                                    { root: true });
                            }
                            this.hideLoading();
                        }).catch(error => {
                            this.hideLoading();
                            this.$store.dispatch('notifications/error',
                                { msg: 'No fue posible agregar rubro' },
                                { root: true });
                        });
                    } else {
                        this.$store.dispatch('loading/spinner', {}, { root: true });
                        this.$store.dispatch('notifications/warning',
                            { msg: 'Por favor complete todos los campos requeridos' },
                            { root: true });
                        this.hideLoading();
                        return false;
                    }
                });
            } else if (catalog == 'App\\Http\\Models\\Cats\\CatRegion') {
                this.$refs['regionForm'].validate((valid) => {
                    if (valid) {
                        let data = {
                            catalog: catalog,
                            form: this.regionForm
                        };
                        axios.post('/api/catalogs', data).then(response => {
                            this.showLoading();
                            let _response = response.data.success;

                            if (_response) {
                                this.getCatalog(catalog);
                                this.addRegion = false;
                                this.$store.dispatch('notifications/ok',
                                    { msg: 'Se agregó un nuevo campo en catálogo' },
                                    { root: true });
                            }
                            else {
                                this.$store.dispatch('notifications/error',
                                    { msg: response.data.message },
                                    { root: true });
                            }
                            this.hideLoading();
                        }).catch(error => {
                            this.hideLoading();
                            this.$store.dispatch('notifications/error',
                                { msg: 'No fue posible agregar rubro' },
                                { root: true });
                        });
                    } else {
                        this.$store.dispatch('loading/spinner', {}, { root: true });
                        this.$store.dispatch('notifications/warning',
                            { msg: 'Por favor complete todos los campos requeridos' },
                            { root: true });
                        this.hideLoading();
                        return false;
                    }
                });
            }
        },

        productEdit(product) {
            this.modalProduct = true;
            this.register = Object.assign({}, product)

        },
        serviceEdit(product) {
            this.modalService = true;
            this.register = Object.assign({}, product)

        },

        subBudgetEdit(subBudget) {
            this.modalSubBudget = true;
            this.register = Object.assign({}, subBudget)
        },

        conceptEdit(concept) {
            this.modalConcept = true;
            this.register = Object.assign({}, concept)
        },

        closeTable() {
            this.showTable = false;
            this.showGeneric = false;
            this.showSubBudget = false;
            this.showProducts = false;
            this.showCurrency = false;
            this.showServiceName = false;
            this.showRegions = false;
            this.selectCat = null;
            this.label = '';
        },

        currencyEdit(currency) {
            this.modalCurrency = true;
            this.register = Object.assign({}, currency)
        },

        checkDeterminant(rule, value, callBack) {
            var patt = new RegExp("^[A-Z]+$");
            if (!value) {
                return callBack(new Error('El campo es requerido'));
            }
            else {
                var res = patt.test(value);
                if (!res) {
                    return callBack(new Error('Este campo solo recibe letras Mayúsculas.'));
                }
            }
            callBack();
        },

        handleCurrentChange2(page) {

            this.currentPage = page;
            this.getCatalog(this.modelName)
        },

        officeEdit(office) {

            this.modalOffice = true;
            this.register = Object.assign({}, office);
            this.showLoading();
            let params = {
                users: this.register.users_ids,
            };
            axios.get('/api/get-users', { params }).then(response => {
                if (response.data.success) {
                    this.users = response.data.users;
                }
                this.hideLoading();
            }).catch(error => {
                this.$store.dispatch('loading/spinner', {}, { root: true });
                this.$store.dispatch('notifications/error',
                    { msg: 'No fue posible mostrar información o no cuenta con autorización.' },
                    { root: true });
            });

        },

        regionEdit(region) {
            this.modalRegion = true;
            this.register = Object.assign({}, region);
        },

        filterStates(states, countryId, type) {

            if (type == 1) {
                if (countryId != '') {
                    return states.filter(up => up.cat_country_id == countryId)
                } else {

                    return this.officeForm.cat_state_id = '';
                }
            } else if (type == 2) {

                if (countryId != '') {
                    return states.filter(up => up.cat_country_id == countryId)
                } else {

                    return this.register.cat_state_id = '';
                }
            }

        },

        tableRowClassName({ row, rowIndex }) {
            if (row.isActive == 0) return 'deActive-row';
            return '';
        },

    }
}
</script>

<style scoped>
.buttonFixed {

    outline: none;
    position: fixed;
    z-index: 99;
    bottom: 2.5em;
    right: 5.5em;
    /*top: 50.0em;*/
    border-radius: 30px;
    font-size: 15px;
    padding: 10px 15px 10px 15px;
    border-radius: 45px;
    background-color: #880000;
    background-image: radial-gradient(circle farthest-corner at 100% 0, #c6153c, transparent);
    border: 1px solid #dcdfe6;
    color: #fff;
}

.buttonFixed:hover {
    cursor: pointer;
    background-color: #880000;
    background-image: radial-gradient(circle farthest-corner at 100% 0, #c6153c, transparent);
}

.buttonFixed:active,
.buttonFixed:visited,
.buttonFixed:link {
    background-color: #333333;
    background-image: radial-gradient(circle farthest-corner at 100% 0, #c6153c, transparent);
}
</style>

<style>
.el-table .deActive-row {
    background: rgba(255, 22, 0, 0.15);
}

.el-table .success-row {
    background: rgba(17, 249, 0, 0.13);
}
</style>